import { BalanceAccountEntity } from "@goodfill/domain-entities";
import { asAccountId, asBalanceAccountId } from "@goodfill/domain-properties";
import { BalanceAccount } from "../API";

export function balanceAccountApiToModel(
  apiBalanceAccount: BalanceAccount
): BalanceAccountEntity {
  return {
    id: asBalanceAccountId(apiBalanceAccount.id),
    accountId: asAccountId(apiBalanceAccount.accountId),
    currency: apiBalanceAccount.currency ?? null,
  };
}
